var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 11.6633H12.2584L12.025 11.4383C13.025 10.2716 13.5417 8.67995 13.2584 6.98828C12.8667 4.67162 10.9334 2.82162 8.60003 2.53828C5.07503 2.10495 2.10837 5.07161 2.5417 8.59662C2.82503 10.9299 4.67503 12.8633 6.9917 13.2549C8.68337 13.5383 10.275 13.0216 11.4417 12.0216L11.6667 12.2549V12.9133L15.2084 16.4549C15.55 16.7966 16.1084 16.7966 16.45 16.4549C16.7917 16.1133 16.7917 15.5549 16.45 15.2133L12.9167 11.6633ZM7.9167 11.6633C5.8417 11.6633 4.1667 9.98828 4.1667 7.91328C4.1667 5.83828 5.8417 4.16328 7.9167 4.16328C9.9917 4.16328 11.6667 5.83828 11.6667 7.91328C11.6667 9.98828 9.9917 11.6633 7.9167 11.6633Z",
    fill: "#3298F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.524978d41cae98f88c147bc4ed387ded.svg";
export { ForwardRef as ReactComponent };